"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TimelineImpl = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var coreHttp = _interopRequireWildcard(require("@azure/core-http"));

var Mappers = _interopRequireWildcard(require("../models/mappers"));

var Parameters = _interopRequireWildcard(require("../models/parameters"));

/*
 * Copyright (c) Microsoft Corporation.
 * Licensed under the MIT License.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is regenerated.
 */

/** Class containing Timeline operations. */
var TimelineImpl = /*#__PURE__*/function () {
  /**
   * Initialize a new instance of the class Timeline class.
   * @param client Reference to the service client
   */
  function TimelineImpl(client) {
    (0, _classCallCheck2["default"])(this, TimelineImpl);
    this.client = client;
  }
  /**
   * Get status of a document timeline. Should it show a timeline, and which type of timeline should be
   * shown.
   * One based on DK law status, one based on versioned documents in a family or one based on regular
   * version relations, which may have multiple branches. (Auth: RhinestoneAuthorize[hiveId, fullName,
   * portalId])
   * @param portalId (Access Controlled)
   * @param hiveId (Access Controlled)
   * @param fullName (Access Controlled)
   * @param options The options parameters.
   */


  (0, _createClass2["default"])(TimelineImpl, [{
    key: "getTimelineStatus",
    value: function getTimelineStatus(portalId, hiveId, fullName, options) {
      var operationArguments = {
        portalId: portalId,
        hiveId: hiveId,
        fullName: fullName,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, getTimelineStatusOperationSpec);
    }
    /**
     * Fetches a version timeline
     *
     * Internally it uses family name of the document to fetch all documents part of the family
     * sorted by their version relations
     *
     * A future change could be to allow fetching the timeline by simply providing the family
     * However, at the time of implementing this there is no authorization mechanism based on family (Auth:
     * RhinestoneAuthorize[hiveId, fullName, portalId])
     * @param portalId (Access Controlled)
     * @param familyName
     * @param hiveId (Access Controlled)
     * @param fullName (Access Controlled)
     * @param options The options parameters.
     */

  }, {
    key: "getVersionBasedHistoryTimeline",
    value: function getVersionBasedHistoryTimeline(portalId, familyName, hiveId, fullName, options) {
      var operationArguments = {
        portalId: portalId,
        familyName: familyName,
        hiveId: hiveId,
        fullName: fullName,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, getVersionBasedHistoryTimelineOperationSpec);
    }
    /**
     * Fetches a version based timeline for a document family, where each node has a legal status, and
     * other properties
     * required for SLR
     * Fullname is not actually used, however, at the time of implementing this there is no authorization
     * mechanism based on family (Auth: RhinestoneAuthorize[hiveId, fullName, portalId])
     * @param portalId (Access Controlled)
     * @param familyName
     * @param hiveId (Access Controlled)
     * @param fullName (Access Controlled)
     * @param options The options parameters.
     */

  }, {
    key: "getDanishLawBasedTimeline",
    value: function getDanishLawBasedTimeline(portalId, familyName, hiveId, fullName, options) {
      var operationArguments = {
        portalId: portalId,
        familyName: familyName,
        hiveId: hiveId,
        fullName: fullName,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, getDanishLawBasedTimelineOperationSpec);
    }
    /**
     *  (Auth: RhinestoneAuthorize[hiveId, fullName, portalId])
     * @param portalId (Access Controlled)
     * @param hiveId (Access Controlled)
     * @param fullName (Access Controlled)
     * @param options The options parameters.
     */

  }, {
    key: "getBranchingHistoryTimeline",
    value: function getBranchingHistoryTimeline(portalId, hiveId, fullName, options) {
      var operationArguments = {
        portalId: portalId,
        hiveId: hiveId,
        fullName: fullName,
        options: coreHttp.operationOptionsToRequestOptionsBase(options || {})
      };
      return this.client.sendOperationRequest(operationArguments, getBranchingHistoryTimelineOperationSpec);
    }
  }]);
  return TimelineImpl;
}(); // Operation Specifications


exports.TimelineImpl = TimelineImpl;
var serializer = new coreHttp.Serializer(Mappers,
/* isXml */
false);
var getTimelineStatusOperationSpec = {
  path: "/api/Portals({portalId})/Document/Timeline/Status/h/{hiveId}/{fullName}",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: Mappers.TimelineStatusDto
    },
    401: {},
    403: {}
  },
  urlParameters: [Parameters.$host, Parameters.portalId, Parameters.hiveId, Parameters.fullName],
  headerParameters: [Parameters.accept],
  serializer: serializer
};
var getVersionBasedHistoryTimelineOperationSpec = {
  path: "/api/Portals({portalId})/Document/Timeline/VersionBased/FamilyName/{familyName}/h/{hiveId}/{fullName}",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: Mappers.DocumentHistoryTimelineDto
    },
    401: {},
    403: {}
  },
  urlParameters: [Parameters.$host, Parameters.portalId, Parameters.hiveId, Parameters.fullName, Parameters.familyName],
  headerParameters: [Parameters.accept],
  serializer: serializer
};
var getDanishLawBasedTimelineOperationSpec = {
  path: "/api/Portals({portalId})/Document/Timeline/LawBased/familyName/{familyName}/h/{hiveId}/{fullName}",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: {
        type: {
          name: "Sequence",
          element: {
            type: {
              name: "Composite",
              className: "LegalTimelineNodeDto"
            }
          }
        }
      }
    },
    401: {},
    403: {}
  },
  urlParameters: [Parameters.$host, Parameters.portalId, Parameters.hiveId, Parameters.fullName, Parameters.familyName],
  headerParameters: [Parameters.accept],
  serializer: serializer
};
var getBranchingHistoryTimelineOperationSpec = {
  path: "/api/Portals({portalId})/Document/Timeline/Branching/h/{hiveId}/{fullName}",
  httpMethod: "GET",
  responses: {
    200: {
      bodyMapper: Mappers.DocumentHistoryTimelineDto
    },
    401: {},
    403: {}
  },
  urlParameters: [Parameters.$host, Parameters.portalId, Parameters.hiveId, Parameters.fullName],
  headerParameters: [Parameters.accept],
  serializer: serializer
};